import { render, staticRenderFns } from "./ColumnHeader.vue?vue&type=template&id=6e6f1376&scoped=true&"
import script from "./ColumnHeader.vue?vue&type=script&lang=js&"
export * from "./ColumnHeader.vue?vue&type=script&lang=js&"
import style0 from "./ColumnHeader.vue?vue&type=style&index=0&id=6e6f1376&prod&ang=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6f1376",
  null
  
)

export default component.exports